export default __webpack_public_path__ + "static/media/blueTiktok.96a7c0a6.svg";